export default {
  title: "Bankrekeningen",

  view: {
    noItems: {
      title: "Nog geen bankrekeningen",
      text: "Klik om een bankrekening toe te voegen"
    }
  },

  input: {
    title: "Bankrekening {{action}}",
    bank: {
      label: "Bank"
    },
    holder: {
      label: "Houder naam"
    },
    iban: {
      label: "IBAN"
    },
    swift: {
      label: "Swift/BIC"
    }
  },

  api: {
    error: {
      bankAccount: {
        found: "Bankrekeningnummer bestaat al",
      },
    },
  },
}
